import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setIsBack } from '../../Redux/store/userSlice';
export default function AuthRouterController() {
  const navigate = useNavigate();
  const hasCheckedRef = useRef(false);
  const userStatus = useSelector((s) => s.user.userStatus);
  const forcedPassword = useSelector((s) => s.user.forcedPassword);
  const roleName = useSelector((s) => s.user.roleName);
  const eddStatus = useSelector((s) => s.user.eddStatus);
  const surveyPending = useSelector((s) => s.user.surveyStatus);
  const hasPendingTraining = useSelector((s) => s.user.hasPendingTraining);
  const isback = useSelector((s) => s.user.isback);
  const isAuthInitialized = useSelector((s) => s.user.isAuthInitialized);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const publicRoutes = [
      '/login',
      '/sign-up',
      '/forgot-password',
      '/privacy-policy',
    ];
    console.log('before any' + location.pathname);

    // ✅ Allow public routes WITHOUT token

    console.log(' before Checking authentication and user status...', {
      userStatus,
      forcedPassword,
      roleName,
      eddStatus,
      surveyPending,
      isback,
      hasPendingTraining,
    });
    console.log('isauth' + isAuthInitialized);
    sessionStorage.setItem('hhhh', isAuthInitialized);

    if (!isAuthInitialized) return;

    const token = localStorage.getItem('jwtToken');
    const expired = localStorage.getItem('sessionExpired');
    if (!token && publicRoutes.includes(location.pathname)) {
      return;
    }
    if (!token) {
      navigate('/login');
      hasCheckedRef.current = true;
      return;
    }

    if (expired) {
      localStorage.removeItem('sessionExpired');
      navigate('/login', { state: { sessionExpired: true } });
      hasCheckedRef.current = true;

      return;
    }

    console.log('Checking authentication and user status...', {
      userStatus,
      forcedPassword,
      roleName,
      eddStatus,
      surveyPending,
      hasPendingTraining,
      isback,
    });
    //        if (isback === true) {
    //   const backPath = location.state?.from;

    //   if (backPath && backPath !== location.pathname) {
    //     navigate(backPath);
    //   } else {
    //     navigate(-1); // browser back fallback
    //   }

    //   dispatch(setIsBack(false)); // reset immediately
    //   return;
    // }
    if (forcedPassword == true || forcedPassword == 'true') {
      navigate('/change-password');
      hasCheckedRef.current = true;
      return;
    }

    // if (roleName === 'customer' && (eddStatus == 'true' || eddStatus == true)) {
    //   navigate('/edd');
    //   hasCheckedRef.current = true;
    //   return;
    // }

    // if (
    //   (roleName === "agency" || roleName === "agency_compliance") &&(userStatus === "active")&&
    //   (surveyPending == true || surveyPending == "true")
    // ) {
    //   navigate("/survey");
    //   hasCheckedRef.current = true;
    //   return;
    // }

    // if (
    //   (roleName === 'agent' || roleName === 'agency_compliance') &&
    //   userStatus === 'active' &&
    //   (hasPendingTraining == true || hasPendingTraining == 'true')
    // ) {
    //   navigate('/training');
    //   hasCheckedRef.current = true;
    //   return;
    // }
  }, [
    isAuthInitialized,
    location.pathname,
    isback,
    roleName,
    hasPendingTraining,
  ]);
  useEffect(() => {
    // if (
    //   (roleName === 'agency' || roleName === 'agency_compliance') &&
    //   (surveyPending == true || surveyPending == 'true')
    // ) {
    //   navigate('/survey');
    //   hasCheckedRef.current = true;
    //   return;
    // }
  }, [surveyPending]);
  return null;
}
